import { useEffect, useState } from "react";
import { infomacesToken } from "../../services/api";
import Loading from "../../utils/Loading";

function ChatIA() {
  const [idAluno, setIdAluno] = useState(null);
  const [idEscola, setIdEscola] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const idA = infomacesToken()?.id_pessoa;
    const idE = infomacesToken()?.id_escola;
    if (idA) {
      setIdAluno(idA);
    } else {
      alert("Erro ao buscar id do aluno.");
      return;
    }
    if (idE) {
      setIdEscola(idE);
    } else {
      alert("Erro ao buscar id da escola.");
      return;
    }
  }, []);

  useEffect(() => {
    if (idAluno && idEscola) {
      setLoading(true);
    }
  }, [idAluno, idEscola]);


  const chatIAUrl = `https://conexao-literaria.institutoyoux.org.br/chat_aluno/?id_escola=${idEscola}&id_aluno=${idAluno}&embed=true`;
  return (
    <div style={{
      width: "100%",
      height: "100%",
      position: "relative",
      overflow: "hidden",
    }}>
      {idEscola && idAluno && (
        <iframe
          title="chatIA"

          style={{ width: "100%", border: "none", height: "100%"}}
          src={chatIAUrl}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            alert("Erro ao carregar chatIA");
          }}
        ></iframe>
      )}
      {loading && (
        <Loading />
      )}
    </div>
  );
}

export default ChatIA;